import { IWebchatTokensRepository } from 'modules/webchat/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

/**
 * Pede ao BFF o token da sala escolhida pelo site. O BFF repassa a sala à
 * Callbell no cookie de sessão, que o navegador não deixaria o site trocar.
 */
export default class CallbellWebchatTokensRepository
  implements IWebchatTokensRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public issue: IWebchatTokensRepository['issue'] = async ({
    channelUuid,
    sessionId,
  }) => {
    const response = await this.httpProvider.post<{ token?: unknown } | null>(
      'chat/sessao',
      { canal: channelUuid, sessao: sessionId },
    );

    const token = response?.token;

    if (typeof token !== 'string' || !token) {
      throw new Error('O BFF não devolveu o token do Webchat');
    }

    return token;
  };
}
